"use client";

import { useState, useEffect } from "react";
import { useSearchParams } from "next/navigation";
import { Coins, RotateCcw, Mail, MapPin, Building2 } from "lucide-react";
import { useTranslations } from "next-intl";
import { Button } from "@/shared/ui/buttons/button";
import { DonateModal } from "./donate-modal";

const TBANK_URL = "https://www.tbank.ru";

export function AboutDonatePaymentBlock() {
  const tDonate = useTranslations("Marketing.About.donate");
  const tPayment = useTranslations("Marketing.About.paymentCompliance");
  const searchParams = useSearchParams();
  const [donateStatus, setDonateStatus] = useState<"success" | "fail" | null>(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const status = searchParams.get("donate");
    if (status === "success" || status === "fail") {
      setDonateStatus(status);
      window.history.replaceState({}, "", "/about");
    }
  }, [searchParams]);

  return (
    <>
      <div className="space-y-6">
        <section>
          {donateStatus === "success" && (
            <p className="mb-3 text-sm text-green-600 dark:text-green-400">
              {tDonate("success")}
            </p>
          )}
          {donateStatus === "fail" && (
            <p className="mb-3 text-sm text-destructive">
              {tDonate("fail")}
            </p>
          )}
          <h2 className="text-sm font-semibold flex items-center gap-2 mb-2">
            <Coins className="h-4 w-4 text-primary" />
            {tDonate("title")}
          </h2>
          <p className="text-muted-foreground text-sm leading-relaxed mb-4">
            {tDonate("desc")}
          </p>
          <Button size="sm" onClick={() => setModalOpen(true)} className="rounded-full gap-1.5">
            <Coins className="h-4 w-4" />
            {tDonate("button")}
          </Button>
        </section>

        <hr className="border-0 h-px bg-border/60" />

        <section>
          <h2 className="text-sm font-semibold flex items-center gap-2 mb-3">
            <Coins className="h-4 w-4 text-primary" />
            {tPayment("title")}
          </h2>
          <div className="space-y-3 text-sm text-muted-foreground">
            <p>
              {tPayment("methods")}{" "}
              <a href={TBANK_URL} target="_blank" rel="noopener noreferrer" className="text-primary underline underline-offset-2">
                tbank.ru
              </a>
            </p>
            <div className="flex items-start gap-2">
              <RotateCcw className="h-4 w-4 shrink-0 mt-0.5" />
              <p>{tPayment("returnPolicy")}</p>
            </div>
            <div className="flex items-start gap-2">
              <Mail className="h-4 w-4 shrink-0 mt-0.5" />
              <p>
                {tPayment("supportLabel")}{" "}
                <a href="mailto:alexandr.nzrnko@yandex.ru" className="text-primary hover:underline">
                  alexandr.nzrnko@yandex.ru
                </a>
              </p>
            </div>
            <div className="flex items-start gap-2">
              <Building2 className="h-4 w-4 shrink-0 mt-0.5" />
              <p>{tPayment("inn")}. {tPayment("fio")}</p>
            </div>
            <div className="flex items-start gap-2">
              <MapPin className="h-4 w-4 shrink-0 mt-0.5" />
              <p>{tPayment("address")}</p>
            </div>
          </div>
        </section>
      </div>
      <DonateModal open={modalOpen} onOpenChange={setModalOpen} />
    </>
  );
}
